import React, { Fragment } from 'react';
import ReactApexChart from 'react-apexcharts';
import { FiChevronUp } from 'react-icons/fi';
import { Card, CardHeader, Col, Row } from 'reactstrap';
import { H4, H5 } from '../../../AbstractElements';

import { Month, Today, TotalEarningChartTitle, Year } from '../../../Constant';
import { radialChart } from '../../../Data/Widgets/Chart/ChartData';

const TotalEarningChart = () => {
  return (
    <Fragment>
      <Col xl='5' md='12' className='box-col-5'>
        <Card className='o-hidden'>
          <CardHeader className='pb-0'>
            <H5>{TotalEarningChartTitle}</H5>
          </CardHeader>
          <div className='bar-chart-widget'>
            <div className='top-content bg-primary'></div>
            <div className='bottom-content card-body'>
              <Row>
                <Col xs='12'>
                  <div id='chart-widget5'>
                    <ReactApexChart options={radialChart.options} series={radialChart.series} height='360' type='radialBar' />
                  </div>
                </Col>
              </Row>
              <Row className='text-center'>
                <Col xs='4' className='b-r-light'>
                  <div>
                    <span className=' font-primary d-flex align-items-center justify-content-center'>
                      12%
                      <FiChevronUp style={{ width: '20px', height: '20px', strokeWidth: '1.1px' }} className='f-12 ms-1' />
                    </span>
                    <span className='text-muted block-bottom'>{Year}</span>
                    <H4 className='num m-0'>
                      <span className='counter color-bottom'>2</span>M
                    </H4>
                  </div>
                </Col>
                <Col xs='4' className='b-r-light'>
                  <div>
                    <span className='font-primary d-flex align-items-center justify-content-center'>
                      15% <FiChevronUp style={{ width: '20px', height: '20px', strokeWidth: '1.1px' }} className='f-12 ms-1' />
                    </span>
                    <span className='text-muted block-bottom'>{Month}</span>
                    <H4 className='num m-0'>
                      <span className='counter color-bottom'>0</span>M
                    </H4>
                  </div>
                </Col>
                <Col xs='4'>
                  <div>
                    <span className='font-primary d-flex align-items-center justify-content-center'>
                      34%
                      <FiChevronUp style={{ width: '20px', height: '20px', strokeWidth: '1.1px' }} className='f-12 ms-1' />
                    </span>
                    <span className='text-muted block-bottom'>{Today}</span>
                    <H4 className='num m-0'>
                      <span className='counter color-bottom'>7</span>M
                    </H4>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Card>
      </Col>
    </Fragment>
  );
};
export default TotalEarningChart;
